var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusinessmodelcanvas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-businessmodelcanvas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17383",
    "data-name": "Ret\\xE2ngulo 17383",
    width: 24,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12787",
    "data-name": "Grupo 12787",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7291",
    "data-name": "Caminho 7291",
    d: "M19,7H15V5h4ZM9,11H5V5H9Zm10,8H15V13h4ZM9,19H5V17H9ZM20,3H14a1,1,0,0,0-1,1V8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1M10,3H4A1,1,0,0,0,3,4v8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1m10,8H14a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V12a1,1,0,0,0-1-1M10,15H4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V16a1,1,0,0,0-1-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessmodelcanvas);
export default __webpack_public_path__ + "static/media/icon-businessmodelcanvas.28aa571e69ee5f2119bb64fde28dbda3.svg";
export { ForwardRef as ReactComponent };